import React, { useMemo, useEffect } from 'react';
import { useAtomValue, useAtom } from 'jotai';

import { env } from '@/lib/env';
import { deviceAtom } from '@/atoms/device';
import { spluginLoadStatusAtom } from '@/atoms/splugin';

const GlobalSocialPlugin: React.FC = () => {
  const device = useAtomValue(deviceAtom);
  const [{ isComplete, error }, setSpluginLoadStatus] = useAtom(spluginLoadStatusAtom);

  const socialPluginScriptSrc = useMemo(
    () =>
      `${env(device === 'mo' ? 'SPLUGIN_SDK_MO_URL' : 'SPLUGIN_SDK_PC_URL')}?v=${Math.floor(new Date().getTime() / 120000)}`,
    [device],
  );

  useEffect(() => {
    const scriptId = 'naver-splugin-sdk';
    let script = document.getElementById(scriptId) as HTMLScriptElement;

    if (!script) {
      script = document.createElement('script');
      script.src = socialPluginScriptSrc;
      script.async = true;
      script.id = scriptId;

      document.getElementsByTagName('head')[0].appendChild(script);
    }

    const handleLoad = () => {
      setSpluginLoadStatus((prev) => ({ ...prev, isComplete: true }));
    };
    const handleError = (error: any) => {
      setSpluginLoadStatus((prev) => ({ ...prev, error }));
    };

    script.addEventListener('load', handleLoad);
    script.addEventListener('error', handleError);

    return () => {
      script.removeEventListener('load', handleLoad);
      script.removeEventListener('error', handleError);
    };
  }, [socialPluginScriptSrc, setSpluginLoadStatus]);

  useEffect(() => {
    if (isComplete && !error) {
      window.__splugin = window.SocialPlugIn_Core({
        evKey: env('SPLUGIN_EVENT_KEY'),
        // sourceName: 'empty',
        serviceName: env('SPLUGIN_SERVICE_NAME'),
        darkMode: false,
      });
    }
  }, [isComplete, error]);

  return null;
};

export default GlobalSocialPlugin;
